import { render, staticRenderFns } from "./StatisticsPayView.vue?vue&type=template&id=4cec3fb6"
import script from "./StatisticsPayView.vue?vue&type=script&lang=js"
export * from "./StatisticsPayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports